module.exports = __webpack_public_path__ + "media/application/images/icons/top-brand-45ccdfa278590aeba1d6957e624398cf.svg";